import type { AuditEvent } from "../lib/types";

/**
 * Recent connection attempts, successes and failures alike.
 *
 * A failed OAuth used to be completely invisible: the reason came back only as
 * a `?error=` parameter, so closing the tab or navigating away lost it and the
 * Connections screen looked exactly as it had before the user consented. This
 * panel is the in-app answer to "I authorised it — why is nothing here?".
 */
export function ConnectionActivity({ events }: { events: AuditEvent[] }) {
  if (events.length === 0) return null;

  return (
    <div className="card">
      <h2>Recent connection attempts</h2>
      <table className="tbl">
        <tbody>
          {events.map((e) => {
            const failed = e.action === "connection.failed";
            const platform = String(e.metadata?.platform ?? "account");
            return (
              <tr key={e.id}>
                <td style={{ whiteSpace: "nowrap" }}>
                  <span className={`chip ${failed ? "err" : "ok"}`}>
                    {failed ? "Failed" : "Connected"}
                  </span>
                </td>
                <td>
                  <strong>{platform}</strong>
                  {failed && (
                    <div className="muted">{String(e.metadata?.error ?? "No reason recorded.")}</div>
                  )}
                </td>
                <td className="muted" style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                  {new Date(e.created_at).toLocaleString()}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
